// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { WizardDeviceStepsEnum } from "./Shared.WizardDeviceStepsEnum.gen";

export interface IWizardStepsResponse {
	id: string | undefined;

	dateCreated: string | undefined;

	organizationId: string | undefined;

	organizationName: string | undefined;

	facilityGroupId: string | undefined;

	facilityGroupName: string | undefined;

	facilityId: string | undefined;

	facilityName: string | undefined;

	deviceId: string | undefined;

	currentStep: WizardDeviceStepsEnum;

	isDeleted: boolean;

	$type?: string | undefined;
}
export class WizardStepsResponse {
	constructor(data?: IWizardStepsResponse) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
	}

	id: string | undefined;

	dateCreated: Date | undefined = new Date();

	organizationId: string | undefined;

	organizationName: string | undefined;

	facilityGroupId: string | undefined;

	facilityGroupName: string | undefined;

	facilityId: string | undefined;

	facilityName: string | undefined;

	deviceId: string | undefined;

	currentStep: WizardDeviceStepsEnum = 0;

	isDeleted: boolean = false;

	static $type: string = "Shared.Models.Api.v1.WizardStepsResponse, ";
	$type?: string | undefined = WizardStepsResponse.$type;
}

